"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var processor_1 = require("./js/src/processor");
exports.SchemaProcessor = processor_1.SchemaProcessor;
//# sourceMappingURL=index.js.map